import { BlockadeTypeId } from '../../components/ExaminersStructure/ExaminersStructure.types';
import { Examiner, ExaminerPermission } from '../../models/taskGroup.types';

export function isExpanded(id: string, expandedItems: string[]): boolean {
  return expandedItems.some((ei) => ei === id);
}

const getExaminerPermission = (examiner: Examiner, assessmentSessionId: string) => {
  if (examiner) {
    const singlePermission: ExaminerPermission[] = examiner.examinerPermission;
    const examinerPermission = singlePermission.find(
      (permission) => permission.assessmentSessionId === assessmentSessionId,
    );
    return examinerPermission ? examinerPermission : ({} as ExaminerPermission);
  } else return {} as ExaminerPermission;
};

export const getExaminerNumberFromPermission = (item: Examiner, assessmentSessionId: string): string => {
  const examinerPermission = getExaminerPermission(item, assessmentSessionId);
  return examinerPermission.examinerNumber ? examinerPermission.examinerNumber : '-';
};

export const getIsExaminerBlocked = (item: Examiner, assessmentSessionId: string): boolean => {
  const permission = getExaminerPermission(item, assessmentSessionId);
  return (permission.isBlocked === BlockadeTypeId.Manual || permission.isBlocked === BlockadeTypeId.Automatic) ? true : false;
};

export const getLockTypeText = (lockType: BlockadeTypeId) => {
  if (lockType === BlockadeTypeId.Manual) return 'manualna';
  if (lockType === BlockadeTypeId.Automatic) return 'automatyczna';
  if (lockType === BlockadeTypeId.None) return 'brak';
};